import {EventPortfolioBO} from "./EventPortfolioBO";
import {ASync} from "../PA.Core/Basic/ASync";

import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";

import * as _ from 'lodash'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

import {Subscription} from "rxjs/Subscription";

export class EventPortfolioBOStandardPolicy
    implements IPolicy {
    _isEditor: boolean
    _PolicyChanged: BehaviorSubject<IPolicy>
    _isLoaded: boolean
    _portfolioBO: EventPortfolioBO

    constructor(portfolioBO: EventPortfolioBO) {
        this._isLoaded = false
        this._isEditor = false
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._portfolioBO = portfolioBO

    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._isLoaded) {
            return ASync.resolve()
        }

        return new Promise<void>((resolve, error) => {
            self._portfolioBO.OnLoadComplete
                .then((ignore) => {

                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                    if (usrContext.User.cif.WB_AUTHUSR_ID == self._portfolioBO.WB_EventPortfolio.cif.WB_AUTHUSR_ID_CREATEDBY)
                        self._isEditor = true
                    else
                        self._isEditor = false

                    self._isLoaded = true
                    self._PolicyChanged.next(self)
                })
                .catch((err) => {

                    self._isEditor = false
                    self._PolicyChanged.next(self)
                })
            //
            resolve()
        })
    }


    get bIsEditor(): boolean {
        return this._isEditor
    }


    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

}


